module.exports = __webpack_public_path__ + "static/media/calendar.0ff9ee20.svg";